import { Injectable, inject } from '@angular/core';
import { CanActivate, CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { TabService } from '../services/tab.service';

@Injectable({
  providedIn: 'root'
})
export class DuplicateTabGuard implements CanActivate, CanMatch {
  private readonly tabService = inject(TabService);
  private readonly router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    return this.resolveGuardResult();
  }

  async canMatch(_route: Route, _segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.resolveGuardResult();
  }

  private async resolveGuardResult(): Promise<boolean | UrlTree> {
    await this.tabService.awaitInitialCheck();
    return this.tabService.isDuplicateSnapshot() ? this.router.createUrlTree(['/duplicate-tab']) : true;
  }
}
